import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../../messages/messagesActions";
import { IAccountingTaxInformation, initialAccountingTaxInformationState } from "./taxInformation.types";

export const FETCH_ACCOUNTING_TAX_INFORMATION_PROGRESS =
  "FETCH_ACCOUNTING_TAX_INFORMATION_PROGRESS";
export const FETCH_ACCOUNTING_TAX_INFORMATION_SUCCESS =
  "FETCH_ACCOUNTING_TAX_INFORMATION_SUCCESS";
export const FETCH_ACCOUNTING_TAX_INFORMATION_FAILURE =
  "FETCH_ACCOUNTING_TAX_INFORMATION_FAILURE";

export const fetchAccountingTaxInformationProgress = () =>
  action(FETCH_ACCOUNTING_TAX_INFORMATION_PROGRESS);
export const fetchAccountingTaxInformationSuccess = (
  data: IAccountingTaxInformation
) => action(FETCH_ACCOUNTING_TAX_INFORMATION_SUCCESS, { data });
export const fetchAccountingTaxInformationFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_TAX_INFORMATION_FAILURE, { errorMessage });

export const fetchAccountingTaxInformationAsync =
  (customerId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingTaxInformationProgress());

      const res = await api.get(
        `/accounting/get-account-company-tax-information?customer_id=${customerId}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingTaxInformationSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingTaxInformationSuccess(initialAccountingTaxInformationState["data"])
        );
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingTaxInformationFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingTaxInformationAysnc =
  (
    data: IAccountingTaxInformation,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress())
      await api.post("/accounting/edit-account-company-tax-information", data);
      const message = "Tax Information saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
    finally {
      dispatch(saveLoaderCompleted())
    }
  };
